import { getStorefront } from "./getStorefront";
import { errorsMsg } from "./hmcConfig";
import { log } from "./logger";

export let translations = {};

export const getTexts = async () => {
  if (JSON.stringify(translations) === JSON.stringify({})) {
    let r = await getStorefront();
    log(r);
    translations = r;
    return r;
  }
  return translations;
};

export const getTranslation = (key) => {
  var tObj = translations[key];
  if (tObj === undefined) return key || errorsMsg.MISSING_TRANSLATION;
  return tObj;
};

String.prototype.supplant = function (o) {
  return this.replace(/{([^{}]*)}/g, function (a, b) {
    var r = o[b];
    return typeof r === "string" || typeof r === "number" ? r : a;
  });
};

export const getTranslationWithParams = (m, v = false) => {
  const text = getTranslation(m);
  if (v) {
    return text.supplant(v);
  } else {
    return text;
  }
};

export const getBooleanStorefront = (k) => {
  return getTranslation(k) == "true" ? true : false;
};
